<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="33"
    height="44"
    viewBox="0 0 33 44"
    fill="none"
  >
    <g clip-path="url(#clip0_1_186)">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17 36C19.322 36 21.508 36.47 23.496 37.397C25.4767 38.3184 27.2431 39.6434 28.682 41.287C29.082 41.744 29.48 42.253 29.862 42.802L30 43H4L4.137 42.802C4.50208 42.2759 4.89601 41.7705 5.317 41.288C6.75607 39.6438 8.52283 38.3185 10.504 37.397C12.492 36.47 14.678 36 17 36ZM16.5 -1C25.598 -1 33 6.402 33 15.5C33 24.598 25.598 32 16.5 32C7.402 32 0 24.598 0 15.5C0 6.402 7.402 -1 16.5 -1ZM16.5 5C10.71 5 6 9.71 6 15.5C6 21.29 10.71 26 16.5 26C22.29 26 27 21.29 27 15.5C27 9.71 22.29 5 16.5 5Z"
        fill="black"
      />
    </g>
    <defs>
      <clipPath id="clip0_1_186">
        <rect width="33" height="44" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
